import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";


export async function getAllContacts(page: number, pageSize: number, q?: string): Promise<DataSourceResult<any>> {
  const headers = userService.getAuthHeaders();

  const body: DataSourceRequest = {
    page,
    pageSize,
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  if (q) {
    body.filters = [
      { field: "name", operator: "contains", value: q, logic: "or" },
      { field: "email", operator: "contains", value: q, logic: "or" },
      { field: "phone", operator: "contains", value: q, logic: "or" },
      { field: "organization", operator: "contains", value: q, logic: "or" },
    ];
  }

  return (await axiosInstance.post<DataSourceResult<any>>("/Contacts/GetContactList", body, { headers })).data;
}


export async function newContact(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Contacts/AddNewContact", data, { headers })).data;
}


export async function updateContact(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Contacts/UpdateContact", data, { headers })).data;
}


export async function getDetails(id: number) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Contacts/GetContactDetails/" + id, { headers })).data;
}


export async function deleteContact(id: number) {
  const headers = userService.getAuthHeaders();
  const params = { id };
  return (await axiosInstance.post("/Contacts/DeleteContact", null, { headers, params })).data;
}


export async function uploadContactsExcelFile(file: File) {
  const headers = userService.getAuthHeaders();
  const formData = new FormData();
  formData.append("formFile", file);
  return (await axiosInstance.post("/Contacts/Import", formData, { headers })).data;
}

export async function UpdateImageContact(file: File, id) {
  const headers = userService.getAuthHeaders();
  const formData = new FormData();
  formData.append("formFile", file);
  return (await axiosInstance.post("/Contacts/UpdateImageContact/" + id, formData, { headers })).data;
}

export async function uploadListImageContact(files: any) {
  const headers = userService.getAuthHeaders();
  const formData = new FormData();
  files.forEach(file => {
    formData.append("imageFiles", file);
  });
  return (await axiosInstance.post("/Contacts/Image/Import", formData, { headers })).data;
}
export async function getAllContactsForExport() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/Contacts/GetAllContact", {headers})).data;
}

export async function deleteAllContacts() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Contacts/DeleteAllContact", null, {headers})).data;
}

export async function importFromApi(apiUrl: string, token: string) {
  const headers = userService.getAuthHeaders();
  const params = { apiUrl, token };
  return (await axiosInstance.post("/Contacts/ImportFromApi", null, { headers, params })).data;
}